module.exports = __webpack_public_path__ + "img/logo_no_r.42d2d2ec.svg";